<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<div id="transport">
	<table class="table table-striped table-hover">
		<thead>
			<tr>
				<th>Pojazd</th>
				<th>Wolne</th>
				<th>Załoga</th>
				<th>Ilość Miejsc</th>
				<th>Zajęte</th>
				<th></th>
				<!--
				<th></th>
-->
			</tr>
		</thead>
		<tbody>
			<tr [ngClass]="{ 'bg-danger': item.selected }" *ngFor="let item of vehicles; index as index">
				<td>{{ item.name }}</td>
				<td>{{ item.seats - item.occupied - item.crew }}</td>
				<td><input type="number" class="form-control" name="crew" [(ngModel)]="item.crew" min="0" /></td>
				<td>{{ item.seats }}</td>
				<td>{{ item.occupied }}</td>
				<td>
					<button class="btn btn-success" (click)="selectRow(item)">
						<i class="fas fa-check"></i> Wybierz
					</button>
				</td>
				<!--
				<td>
					<button class="btn btn-warning" (click)="remove(index)">
						<i class="fas fa-times"></i> Usuń
					</button>
				</td>
-->
			</tr>
		</tbody>
	</table>
	<div class="d-grid" *ngIf="editable">
		<button type="button" class="btn btn-primary" (click)="vehicleOpen()">
			<i class="fas fa-plus"></i>
			Dodaj pojazd
		</button>
	</div>
</div>

<div
	class="modal fade"
	id="vehicleModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="vehicleModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Wybierz pojazd</h5>
				<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="vehicleClose()">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body d-grid">
				<button
					type="submit"
					class="btn btn-link"
					*ngFor="let item of vehiclesAll"
					(click)="vehicleChoose(item)"
				>
					{{ item.name }}
				</button>
			</div>
		</div>
	</div>
</div>
